import { createElement, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { Menu, MenuProps } from './Menu';

export const MenuContainer = () => {
  const history = useNavigate();

  const onClickItem = useCallback(
    (key: string) => {
      history(key);
    },
    [history],
  );

  const props: MenuProps = {
    onClickItem,
  };
  return createElement(Menu, props);
};
